import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { esES, zhCN, frFR } from "@clerk/localizations";
import { getLang, t } from "@/i18n";

const CLERK_LOCALES = {
  es: { ...esES, signIn: { ...esES.signIn, start: { ...esES.signIn?.start, titleCombined: "Continuar a {{applicationName}}" } } },
  zh: zhCN,
  fr: frFR,
};

const appearance = {
  variables: { colorPrimary: "#2563EB", fontFamily: "Geist, -apple-system, sans-serif", borderRadius: "0.9rem", colorBackground: "#FFFDF9" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>{t("Sign-in is unavailable right now. Refresh the page to try again.")}</p>;
  if (!config) return <p style={{ padding: 24, opacity: 0.6 }} data-testid="clerk-config-loading">{t("Loading SMBOI…")}</p>;
  return (
    <ClerkProvider
      localization={CLERK_LOCALES[getLang()]}
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
